(function () {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const routes = {
    cart: root + 'cart.js',
    add: root + 'cart/add.js',
    change: root + 'cart/change.js'
  };

  const header = document.querySelector('.site-header');

  function setSearchHeader(on) {
    var h = document.querySelector('[data-header]') || document.querySelector('.site-header');
    document.body.classList.toggle('search-open', on);
    document.documentElement.classList.toggle('search-open', on);
    if (!h) return;
    h.classList.toggle('is-search-open', on);
    if (on) {
      h.style.setProperty('background', '#ffffff', 'important');
      h.style.setProperty('background-color', '#ffffff', 'important');
      h.style.setProperty('color', '#1a1a18', 'important');
    } else {
      h.style.removeProperty('background');
      h.style.removeProperty('background-color');
      h.style.removeProperty('color');
    }
  }

  document.querySelectorAll('.header__nav-item').forEach((item) => {
    const mega = item.querySelector('.header__mega');
    if (!mega) return;
    let timer = null;
    const open = () => {
      clearTimeout(timer);
      item.classList.add('is-mega-open');
    };
    const close = () => {
      timer = setTimeout(() => item.classList.remove('is-mega-open'), 120);
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', close);
  });

  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(() => {
      el.classList.add('is-open');
      document.body.classList.add('drawer-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    document.body.style.overflow = '';
    setTimeout(() => { el.hidden = true; }, 320);
  }
  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  }

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const accountDrawer = document.querySelector('[data-account-drawer]');

  document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      var open = mobileMenu && mobileMenu.classList.contains('is-open');
      if (open) {
        closeDrawer(mobileMenu);
        resetMobileMenu();
        btn.setAttribute('aria-expanded', 'false');
      } else {
        openDrawer(mobileMenu);
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      closeDrawer(mobileMenu);
      resetMobileMenu();
      document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });
  });
  function resetMobileMenu() {
    if (!mobileMenu) return;
    var root = mobileMenu.querySelector('[data-mm-root]');
    mobileMenu.querySelectorAll('[data-mm-sub]').forEach(function (el) { el.hidden = true; });
    if (root) root.hidden = false;
  }
  if (mobileMenu) {
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) {
        closeDrawer(mobileMenu);
        resetMobileMenu();
        document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
    });
    mobileMenu.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        closeDrawer(mobileMenu);
        resetMobileMenu();
        document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      });
    });
    mobileMenu.querySelectorAll('[data-mm-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-mm-open');
        var sub = mobileMenu.querySelector('[data-mm-sub="' + id + '"]');
        var root = mobileMenu.querySelector('[data-mm-root]');
        if (!sub) return;
        if (root) root.hidden = true;
        sub.hidden = false;
        mobileMenu.querySelector('.drawer__panel').scrollTop = 0;
      });
    });
    mobileMenu.querySelectorAll('[data-mm-back]').forEach(function (btn) {
      btn.addEventListener('click', resetMobileMenu);
    });
  }

  document.querySelectorAll('[data-search-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      openDrawer(searchDrawer);
      setSearchHeader(true);
      setTimeout(() => {
        const input = searchDrawer && searchDrawer.querySelector('[data-search-input]');
        if (input) input.focus();
      }, 80);
    });
  });
  function closeSearch() {
    closeDrawer(searchDrawer);
    setSearchHeader(false);
  }
  document.querySelectorAll('[data-search-close]').forEach((btn) => {
    btn.addEventListener('click', closeSearch);
  });
  if (searchDrawer) {
    searchDrawer.addEventListener('click', (e) => {
      if (e.target === searchDrawer) closeSearch();
    });
  }

  document.querySelectorAll('[data-account-open]').forEach((btn) => {
    btn.addEventListener('click', () => openDrawer(accountDrawer));
  });
  document.querySelectorAll('[data-account-close]').forEach((btn) => {
    btn.addEventListener('click', () => closeDrawer(accountDrawer));
  });
  if (accountDrawer) {
    accountDrawer.addEventListener('click', (e) => {
      if (e.target === accountDrawer) closeDrawer(accountDrawer);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllDrawers();
      setSearchHeader(false);
    }
  });

  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  let searchTimer = null;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(async () => {
        try {
          const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5';
          const res = await fetch(url);
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            searchResults.innerHTML = '<p class="search-overlay__hint">No results</p>';
            return;
          }
          const allUrl = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
          searchResults.innerHTML = '<p class="search-overlay__label">Products</p><div class="search-overlay__grid">' + products.map((p) => {
            const img = p.image || '';
            const price = p.price || '';
            return '<a class="search-overlay__item" href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              '<span class="search-overlay__item-title">' + escapeHtml(p.title) + '</span>' +
              (price ? '<span class="search-overlay__item-price">' + escapeHtml(price) + '</span>' : '') +
              '</a>';
          }).join('') + '</div><a class="search-overlay__all" href="' + allUrl + '">View all results</a>';
        } catch (err) {
          searchResults.innerHTML = '<p class="search-overlay__hint">Search unavailable</p>';
        }
      }, 250);
    });
  }

  document.querySelectorAll('.drawer [data-locale-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });

  function formatMoney(cents) {
    var value = Number(cents);
    if (isNaN(value)) return '';
    var format = window.themeMoneyFormat || '{{amount}}';
    var formatted = '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        formatted = Shopify.formatMoney(value, format);
      } catch (e) {}
    }
    if (!formatted) {
      var abs = Math.abs(value);
      var major = Math.floor(abs / 100);
      var minor = abs % 100;
      var thousandsDot = String(major).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (minor < 10 ? '0' : '') + minor;
      var thousandsComma = String(major).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + (minor < 10 ? '0' : '') + minor;
      formatted = String(format);
      formatted = formatted.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, thousandsDot);
      formatted = formatted.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(major).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
      formatted = formatted.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(major));
      formatted = formatted.replace(/\{\{\s*amount\s*\}\}/g, thousandsComma);
    }
    if (value % 100 === 0) {
      formatted = formatted.replace(/([.,]00)(?!\d)/g, '');
    }
    return formatted;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&')
      .replace(/</g, '<')
      .replace(/>/g, '>')
      .replace(/"/g, '"');
  }

  const cartDrawer = document.getElementById('cart-drawer');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach((el) => {
    el.addEventListener('click', closeCart);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', String(count));
    });
  }

  function renderCart(cart) {
    const body = document.querySelector('[data-cart-body]');
    const total = document.querySelector('[data-cart-total]');
    const checkoutBtn = document.querySelector('[data-checkout-btn]');
    if (!body) return;
    updateCartCount(cart.item_count);
    if (total) total.textContent = formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Dein Warenkorb ist leer.</p>';
      return;
    }

    body.innerHTML = cart.items.map((item) => {
      const img = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="100" loading="lazy">'
        : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      return (
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__image">' + img + '</div>' +
          '<div class="cart-item__info">' +
            '<a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-item__qty">' +
              '<button type="button" data-qty-change data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-change data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-qty-change data-key="' + item.key + '" data-qty="0" aria-label="Entfernen">×</button>' +
        '</div>'
      );
    }).join('');
  }

  async function fetchCart() {
    const res = await fetch(routes.cart, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    try {
      const res = await fetch(routes.change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: parseInt(btn.dataset.qty, 10) })
      });
      renderCart(await res.json());
    } catch (err) { console.error(err); }
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const buttons = [
        form.querySelector('[type="submit"]'),
        document.querySelector('.mobile-atc [type="submit"]')
      ].filter(Boolean);
      buttons.forEach((b) => {
        b.disabled = true;
        b.dataset.original = b.dataset.original || b.textContent;
        b.textContent = '…';
      });
      try {
        const res = await fetch(routes.add, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Fehler');
        }
        renderCart(await fetchCart());
        openCart();
      } catch (err) {
        console.error(err);
        alert(err.message || 'Fehler beim Hinzufügen');
      } finally {
        buttons.forEach((b) => {
          b.disabled = false;
          b.textContent = b.dataset.original || 'In den Warenkorb';
        });
      }
    });
  });

  fetchCart().then((cart) => { updateCartCount(cart.item_count); renderCart(cart); }).catch(() => {});

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    let variants = [];
    try {
      var variantsEl = document.getElementById('ProductVariantsJson');
      if (variantsEl) variants = JSON.parse(variantsEl.textContent || '[]');
      else if (productForm.dataset.variants) variants = JSON.parse(productForm.dataset.variants);
    } catch (_) {}
    const variantInput = productForm.querySelector('[name="id"]');
    const priceEls = document.querySelectorAll('[data-product-price]');

    function selectedOptions() {
      const opts = [];
      productForm.querySelectorAll('[data-option-group]').forEach((group) => {
        const active = group.querySelector('.is-active');
        if (active) opts.push(active.dataset.value);
      });
      return opts;
    }

    function findVariant() {
      const selected = selectedOptions();
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }

    function filterGalleryByColor(color) {
      const stack = document.querySelector('.product-gallery__stack');
      const track = document.getElementById('galleryTrack');
      const dotsWrap = document.querySelector('.product-gallery__dots');
      if (!stack || !color) return;

      const all = Array.from(document.querySelectorAll('[data-product-media]'));
      if (!all.length) return;

      const colorLower = color.toLowerCase();
      let matched = all.filter((el) => {
        const c = (el.dataset.mediaColor || el.dataset.alt || '').toLowerCase();
        return c.indexOf(colorLower) !== -1;
      });
      if (!matched.length) matched = all;

      stack.innerHTML = matched.map((el, i) =>
        '<div class="product-gallery__img' + (i === 0 ? ' is-active' : '') + '"><img src="' + el.dataset.src + '" srcset="' + (el.dataset.srcset || '') + '" sizes="(min-width: 901px) 42vw, 100vw" alt="' + (el.dataset.alt || '') + '" loading="lazy" decoding="async"></div>'
      ).join('');
      var thumbs = document.querySelector('[data-gallery-thumbs]');
      if (thumbs) {
        thumbs.innerHTML = matched.map((el, i) =>
          '<button type="button" class="product-gallery__thumb' + (i === 0 ? ' is-active' : '') + '" data-gallery-thumb data-index="' + i + '" aria-label="Image ' + (i + 1) + '"><img src="' + el.dataset.src + '" alt="" width="56" height="70" loading="lazy"></button>'
        ).join('');
      }

      if (track) {
        track.innerHTML = matched.map((el) =>
          '<div class="product-gallery__slide"><img src="' + el.dataset.src + '" srcset="' + (el.dataset.srcset || '') + '" sizes="100vw" alt="' + (el.dataset.alt || '') + '" draggable="false" decoding="async"></div>'
        ).join('');
      }
      if (dotsWrap) {
        dotsWrap.innerHTML = matched.map((_, i) =>
          '<button type="button" class="product-gallery__dot' + (i === 0 ? ' is-active' : '') + '" data-gallery-dot data-index="' + i + '" aria-label="Image ' + (i + 1) + '"></button>'
        ).join('');
      }
      initSwipe();
    }

    function updateVariantUI() {
      const variant = findVariant();
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      var priceText = variant.price_formatted || formatMoney(variant.price);
      priceEls.forEach((el) => { el.textContent = priceText; });

      document.querySelectorAll('[data-product-form] [type="submit"], .mobile-atc [type="submit"]').forEach((submit) => {
        submit.disabled = !variant.available;
        if (!variant.available) {
          submit.textContent = submit.dataset.soldOut || 'Ausverkauft';
        } else if (submit.closest('.mobile-atc')) {
          submit.textContent = submit.dataset.addShort || 'In den Warenkorb';
        } else {
          submit.innerHTML = (submit.dataset.addText || 'In den Warenkorb') + ' – <span data-product-price>' + priceText + '</span>';
        }
      });

      productForm.querySelectorAll('[data-option-group]').forEach((group) => {
        const label = group.querySelector('[data-option-selected]');
        const active = group.querySelector('.is-active');
        if (label && active) label.textContent = active.dataset.value;
      });

      const groups = productForm.querySelectorAll('[data-option-group]');
      groups.forEach((group) => {
        const name = (group.dataset.optionName || '').toLowerCase();
        if (/color|colour|farbe/.test(name)) {
          const active = group.querySelector('.is-active');
          if (active) {
            filterGalleryByColor(active.dataset.value);
            if (typeof window.rwrkTintLogo === 'function') window.rwrkTintLogo();
          }
        }
      });
    }

    productForm.querySelectorAll('[data-option-group]').forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          updateVariantUI();
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger], .product-accordion__trigger');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item], .product-accordion__item');
    if (!item) return;
    e.preventDefault();
    var parent = item.parentElement;
    var wasOpen = item.classList.contains('is-open');
    if (parent) {
      parent.querySelectorAll('[data-accordion-item], .product-accordion__item').forEach(function (el) {
        el.classList.remove('is-open');
        var ic = el.querySelector('[data-accordion-trigger] span, .product-accordion__trigger span');
        if (ic) ic.textContent = '+';
      });
    }
    if (!wasOpen) {
      item.classList.add('is-open');
      var icon = trigger.querySelector('span');
      if (icon) icon.textContent = '−';
    }
  });

  function initSwipe() {
    const swipe = document.getElementById('gallerySwipe');
    const track = document.getElementById('galleryTrack');
    if (!swipe || !track) return;

    let index = 0, startX = 0, currentX = 0, dragging = false, width = 0;

    function dots() { return Array.from(document.querySelectorAll('[data-gallery-dot]')); }

    function update(animate) {
      width = swipe.offsetWidth;
      const slides = track.children.length;
      index = Math.max(0, Math.min(slides - 1, index));
      track.style.transition = animate !== false ? 'transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)' : 'none';
      track.style.transform = 'translateX(' + (-index * width) + 'px)';
      dots().forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function goTo(i) { index = i; update(true); }

    const dotsWrap = document.querySelector('.product-gallery__dots');
    if (dotsWrap && !dotsWrap.dataset.bound) {
      dotsWrap.dataset.bound = '1';
      dotsWrap.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-gallery-dot]');
        if (dot) goTo(+dot.dataset.index);
      });
    }

    if (!swipe.dataset.bound) {
      swipe.dataset.bound = '1';
      swipe.addEventListener('touchstart', (e) => {
        dragging = true;
        startX = e.touches[0].clientX;
        currentX = startX;
        width = swipe.offsetWidth;
        track.style.transition = 'none';
      }, { passive: true });

      swipe.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        currentX = e.touches[0].clientX;
        track.style.transform = 'translateX(' + (-index * width + (currentX - startX)) + 'px)';
      }, { passive: true });

      swipe.addEventListener('touchend', () => {
        if (!dragging) return;
        dragging = false;
        const delta = currentX - startX;
        if (delta < -50) goTo(index + 1);
        else if (delta > 50) goTo(index - 1);
        else update(true);
      });

      window.addEventListener('resize', () => update(false));
    }
    update(false);
  }
  initSwipe();

  document.querySelectorAll('[data-locale-toggle]').forEach((toggle) => {
    const wrap = toggle.closest('.header__localization') || toggle.parentElement;
    const dropdown = wrap.querySelector('[data-locale-dropdown]');
    if (!dropdown) return;

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isHidden = dropdown.hasAttribute('hidden');
      document.querySelectorAll('[data-locale-dropdown]').forEach((d) => d.setAttribute('hidden', ''));
      if (isHidden) dropdown.removeAttribute('hidden');
    });

    dropdown.addEventListener('click', (e) => e.stopPropagation());
    dropdown.addEventListener('mousedown', (e) => e.stopPropagation());

    dropdown.querySelectorAll('[data-locale-select]').forEach((select) => {
      select.addEventListener('click', (e) => e.stopPropagation());
      select.addEventListener('mousedown', (e) => e.stopPropagation());
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });
    dropdown.querySelectorAll('[data-locale-option]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = btn.closest('form');
        if (!form) return;
        const name = btn.getAttribute('data-name');
        const value = btn.getAttribute('data-value');
        let input = form.querySelector('input[name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
        form.submit();
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.header__localization')) return;
    document.querySelectorAll('[data-locale-dropdown]').forEach((d) => d.setAttribute('hidden', ''));
  });

  document.querySelectorAll('.product-card').forEach(function (card) {
    var image = card.querySelector('.product-card__image');
    var slides = Array.prototype.slice.call(card.querySelectorAll('[data-card-slide]'));
    var prev = card.querySelector('[data-card-prev]');
    var next = card.querySelector('[data-card-next]');
    var isGallery = card.hasAttribute('data-card-gallery') && slides.length > 1;
    var index = 0;

    function show(i) {
      if (!isGallery) return;
      index = (i + slides.length) % slides.length;
      for (var n = 0; n < slides.length; n++) {
        if (n === index) slides[n].classList.add('is-active');
        else slides[n].classList.remove('is-active');
      }
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(index + 1);
      });
    }

    if (isGallery && image) {
      var startX = 0;
      image.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
      }, { passive: true });
      image.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) show(index + 1);
        else show(index - 1);
      }, { passive: true });
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-card-prev], [data-card-next]')) return;
    var card = e.target.closest('.product-card');
    if (!card) return;
    var url = card.getAttribute('data-product-url');
    if (!url) return;
    if (e.target.closest('a[href]')) return;
    window.location.href = url;
  });

  var sizeDrawer = document.querySelector('[data-size-chart-drawer]');
  document.querySelectorAll('[data-size-chart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!sizeDrawer) return;
      sizeDrawer.hidden = false;
      requestAnimationFrame(function () { sizeDrawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    });
  });
  function closeSizeChart() {
    if (!sizeDrawer) return;
    sizeDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { sizeDrawer.hidden = true; }, 300);
  }
  document.querySelectorAll('[data-size-chart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSizeChart);
  });
  if (sizeDrawer) {
    sizeDrawer.addEventListener('click', function (e) {
      if (e.target === sizeDrawer) closeSizeChart();
    });
  }
  document.querySelectorAll('[data-size-unit-toggle]').forEach(function (wrap) {
    wrap.querySelectorAll('[data-size-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('[data-size-unit]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var unit = btn.getAttribute('data-size-unit');
        document.querySelectorAll('[data-unit-table]').forEach(function (tbl) {
          tbl.hidden = tbl.getAttribute('data-unit-table') !== unit;
        });
      });
    });
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var i = Number(thumb.getAttribute('data-index') || 0);
    var imgs = document.querySelectorAll('.product-gallery__img');
    imgs.forEach(function (el, n) {
      el.classList.toggle('is-active', n === i);
    });
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.classList.toggle('is-active', b === thumb);
    });
    if (imgs[i]) {
      var top = imgs[i].getBoundingClientRect().top + window.pageYOffset - 72;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });

  var localeDrawer = document.querySelector('[data-locale-drawer]');
  document.querySelectorAll('[data-locale-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!localeDrawer) return;
      localeDrawer.hidden = false;
      requestAnimationFrame(function () { localeDrawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    });
  });
  function closeLocaleDrawer() {
    if (!localeDrawer) return;
    localeDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { localeDrawer.hidden = true; }, 300);
  }
  document.querySelectorAll('[data-locale-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeLocaleDrawer);
  });
  if (localeDrawer) {
    localeDrawer.addEventListener('click', function (e) {
      if (e.target === localeDrawer) closeLocaleDrawer();
    });
    localeDrawer.querySelectorAll('[data-locale-option]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = btn.closest('form');
        if (!form) return;
        var name = btn.getAttribute('data-name');
        var value = btn.getAttribute('data-value');
        var input = form.querySelector('input[name="' + name + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
        form.querySelectorAll('[data-locale-option][data-name="' + name + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        if (name === 'country_code') {
          var label = localeDrawer.querySelector('[data-country-current-label]');
          if (label) label.textContent = btn.getAttribute('data-label') || value;
          var list = localeDrawer.querySelector('[data-country-list]');
          if (list) list.hidden = true;
        }
      });
    });
    var countryToggle = localeDrawer.querySelector('[data-country-toggle]');
    var countryList = localeDrawer.querySelector('[data-country-list]');
    var countrySearch = localeDrawer.querySelector('[data-country-search]');
    if (countryToggle && countryList) {
      countryToggle.addEventListener('click', function (e) {
        e.preventDefault();
        countryList.hidden = !countryList.hidden;
        if (!countryList.hidden && countrySearch) {
          countrySearch.value = '';
          countryList.querySelectorAll('.locale-drawer__row').forEach(function (row) {
            row.style.display = '';
          });
          setTimeout(function () { countrySearch.focus(); }, 50);
        }
      });
    }
    if (countrySearch && countryList) {
      countrySearch.addEventListener('input', function () {
        var term = this.value.toLowerCase().trim();
        countryList.querySelectorAll('.locale-drawer__row').forEach(function (row) {
          var name = (row.getAttribute('data-country-name') || '').toLowerCase();
          row.style.display = (!term || name.indexOf(term) !== -1) ? '' : 'none';
        });
      });
      countrySearch.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('template-index')) return;
    var hero = e.target.closest('.hero, .hero__bg, .hero__bg-img');
    if (!hero) return;
    if (e.target.closest('a, button, input, .site-header, .header__logo, .header__nav, .header__actions')) return;
    window.location.href = '/collections/all';
  });

  (function initLogoTint() {
    if (!document.body.classList.contains('template-product')) return;
    var wrap = document.querySelector('.header__logo');
    var img = wrap && wrap.querySelector('.header__logo-main, img');
    if (!wrap || !img) return;

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    svg.innerHTML = '<filter id="rwrkLogoTint" color-interpolation-filters="sRGB"><feFlood id="rwrkLogoFlood" flood-color="#000000" result="flood"/><feComposite in="flood" in2="SourceAlpha" operator="in"/></filter>';
    document.body.appendChild(svg);
    img.style.setProperty('filter', 'url(#rwrkLogoTint)', 'important');
    img.style.setProperty('opacity', '1', 'important');

    function isUsableColor(c) {
      if (!c) return false;
      c = c.trim().toLowerCase();
      if (!c || c === 'transparent' || c === 'inherit' || c === 'none') return false;
      if (c.indexOf('rgba(0, 0, 0, 0)') !== -1 || c.indexOf('rgba(0,0,0,0)') !== -1) return false;
      return true;
    }

    function apply() {
      var s = document.querySelector('.product-form__swatch.is-active');
      if (!s) {
        document.querySelectorAll('[data-option-group]').forEach(function (group) {
          var name = (group.dataset.optionName || '').toLowerCase();
          if (/color|colour|farbe/.test(name)) {
            s = group.querySelector('.is-active');
          }
        });
      }
      var color = '#000000';
      if (s) {
        var raw = (
          s.style.getPropertyValue('--swatch') ||
          getComputedStyle(s).getPropertyValue('--swatch') ||
          ''
        ).trim();
        if (isUsableColor(raw)) color = raw;
      }
      var flood = document.getElementById('rwrkLogoFlood');
      if (flood) flood.setAttribute('flood-color', color);
    }

    window.rwrkTintLogo = apply;
    apply();
    setTimeout(apply, 200);
  })();
})();

(function initWindPoem() {
  var root = document.querySelector('[data-wind-poem]');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 801) return;

  var staticEl = root.querySelector('.wind-poem__static') || root;
  var lines = (staticEl.innerText || '').replace(/\r/g, '').split('\n');
  if (!lines.join('').trim()) return;

  var letters = [];
  var frag = document.createDocumentFragment();
  lines.forEach(function (line, i) {
    if (i) frag.appendChild(document.createElement('br'));
    for (var c = 0; c < line.length; c++) {
      var ch = line.charAt(c);
      if (ch === ' ') {
        frag.appendChild(document.createTextNode(' '));
        continue;
      }
      var span = document.createElement('span');
      span.className = 'wind-char';
      span.textContent = ch;
      frag.appendChild(span);
      letters.push({ el: span, ox: 0, oy: 0, vx: 0, vy: 0, rx: 0, ry: 0 });
    }
  });
  staticEl.textContent = '';
  staticEl.appendChild(frag);

  var mouse = { x: 0, y: 0, px: 0, py: 0, on: false };
  var ticking = false;

  function cacheRest() {
    var b = root.getBoundingClientRect();
    letters.forEach(function (L) {
      var r = L.el.getBoundingClientRect();
      L.rx = r.left - b.left + r.width / 2 - L.ox;
      L.ry = r.top - b.top + r.height / 2 - L.oy;
    });
  }

  function kick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(tick);
  }

  root.addEventListener('pointerenter', function (e) {
    var b = root.getBoundingClientRect();
    mouse.x = mouse.px = e.clientX - b.left;
    mouse.y = mouse.py = e.clientY - b.top;
    mouse.on = true;
    cacheRest();
    kick();
  });
  root.addEventListener('pointerleave', function () { mouse.on = false; kick(); });
  root.addEventListener('pointermove', function (e) {
    var b = root.getBoundingClientRect();
    mouse.px = mouse.x;
    mouse.py = mouse.y;
    mouse.x = e.clientX - b.left;
    mouse.y = e.clientY - b.top;
    mouse.on = true;
    kick();
  });

  window.addEventListener('resize', function () {
    letters.forEach(function (L) {
      L.ox = L.oy = L.vx = L.vy = 0;
      L.el.style.transform = '';
    });
    cacheRest();
  });

  cacheRest();

  function tick() {
    var still = true;
    var ease = mouse.on ? 0.07 : 0.05;

    letters.forEach(function (L) {
      var tx = 0;
      var ty = 0;
      if (mouse.on) {
        var dx = L.rx - mouse.x;
        var dy = L.ry - mouse.y;
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var radius = 140;
        if (dist < radius) {
          var t = 1 - dist / radius;
          t = t * t * (3 - 2 * t);
          var push = t * 4.5;
          tx = (dx / dist) * push;
          ty = (dy / dist) * push;
        }
      }
      L.ox += (tx - L.ox) * ease;
      L.oy += (ty - L.oy) * ease;

      if (Math.abs(L.ox) < 0.04 && Math.abs(L.oy) < 0.04) {
        L.ox = L.oy = 0;
        L.el.style.transform = '';
      } else {
        still = false;
        L.el.style.transform = 'translate(' + L.ox.toFixed(2) + 'px,' + L.oy.toFixed(2) + 'px)';
      }
    });

    if (!still || mouse.on) requestAnimationFrame(tick);
    else ticking = false;
  }
})();

(function () {
  var h = document.querySelector('[data-header]') || document.querySelector('.site-header');
  if (!h) return;
  var lastY = window.pageYOffset || 0;
  function desktopHome() {
    return document.body.classList.contains('template-index') && window.innerWidth >= 901;
  }
  function show() {
    h.classList.remove('is-hidden');
    h.style.removeProperty('transform');
    h.style.removeProperty('visibility');
    if (desktopHome()) {
      h.style.removeProperty('pointer-events');
    } else {
      h.style.setProperty('pointer-events', 'auto', 'important');
    }
  }
  function hide() {
    if (desktopHome()) { show(); return; }
    h.classList.add('is-hidden');
    h.style.setProperty('transform', 'translateY(-100%)', 'important');
    h.style.setProperty('visibility', 'hidden', 'important');
    h.style.setProperty('pointer-events', 'none', 'important');
  }
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (desktopHome() || y < 8) show();
    else if (y > lastY) hide();
    else if (y < lastY) show();
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  onScroll();
})();
